import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  OfferResult,
  ShoppingCartValidation,
  ShoppingCartValidationError,
  ShoppingCartValidationResult
} from '../../types'

const initialState: ShoppingCartValidation = {
  isCartValidationOpen: false,
  latestOffers: [],
  validationErrors: [],
  lastValidated: null
}

export const shoppingCartValidationSlice = createSlice({
  name: 'shoppingCartValidation',
  initialState,
  reducers: {
    showCartValidations: (state: ShoppingCartValidation) => {
      return {
        ...state,
        isCartValidationOpen: true
      }
    },
    hideCartValidations: (state: ShoppingCartValidation) => {
      return {
        ...state,
        isCartValidationOpen: false
      }
    },
    validateCart: (
      state: ShoppingCartValidation,
      action: PayloadAction<ShoppingCartValidationResult>
    ) => {
      const {
        latestOffers = [],
        validationErrors = [],
        lastValidated = new Date().toISOString()
      }: ShoppingCartValidationResult = action.payload

      return {...state, latestOffers, validationErrors, lastValidated}
    },
    clearValidations: (state: ShoppingCartValidation) => {
      return {
        ...state,
        latestOffers: [],
        validationErrors: []
      }
    }
  }
})

// selectors

/**
 * Gets the shopping cart validation errors
 */
export const selectCartValidationErrors = (
  state: any
): ShoppingCartValidationError[] => {
  return state.shoppingCartValidation?.validationErrors || []
}

/**
 * Gets the latst offers
 */
export const selectLatestOffers = (state: any): OfferResult[] => {
  return state.shoppingCartValidation?.latestOffers || []
}

/**
 * Gets the validation modal open state
 */
export const selectIsCartValidationOpen = (state: any): boolean => {
  return state.shoppingCartValidation?.isCartValidationOpen || false
}

// actions
export const {
  clearValidations,
  hideCartValidations,
  showCartValidations,
  validateCart
} = shoppingCartValidationSlice.actions

// reducer
export default shoppingCartValidationSlice.reducer
